import { useEffect, useState, useReducer } from 'react';
import { Container, Button, LoadingOverlay, Alert, Title, Space, Text, Grid } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import * as App from "../../model/App";
import { ChangeEmailModal, ChangePasswordModal, AttorneyRow } from "./../../components";

function SettingsScreen() {
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [isLoadingManual, setIsLoadingManual] = useState(false);
    const [isShowingChangeEmail, setIsShowingChangeEmail] = useState<boolean>(false);
    const [isShowingChangePassword, setIsShowingChangePassword] = useState<boolean>(false);
    const userID = App.Firebase.Auth.getCurrentUserID();
    const { isLoading, isError, data } = useQuery(["userDemographics"], () => { return App.Firebase.Read.getUserDemographics(userID + ""); });

    return (
        <Container ml={0}>
            <Title>Account Settings</Title>
            <LoadingOverlay visible={isLoading || isLoadingManual} />
            {isError && <Alert color="red" title="Error">Error loading data</Alert>}

            <Text>Logged in as: <strong>{data?.email}</strong></Text>
            <Text size="xs">{userID}</Text>

            <ChangeEmailModal visible={isShowingChangeEmail} onClose={() => { setIsShowingChangeEmail(false); }} />
            <ChangePasswordModal visible={isShowingChangePassword} onClose={() => { setIsShowingChangePassword(false); }} />
            
            <Space w="md" h="md" />
            <Button variant="outline" onClick={() => { setIsShowingChangeEmail(true) }}>Update Email</Button>
            <Space w="md" h="md" />
            <Button variant="outline" onClick={() => { setIsShowingChangePassword(true) }}>Update Password</Button>

            {/* Attorneys */}
            <Space h="md" />
            <Text style={{ fontWeight: "bold" }}>Attorneys</Text>
            <Button onClick={() => { 
                if (data && !data.attorneys) { data.attorneys = []; }
                data?.attorneys.push(""); 
                forceUpdate();
            }}>Add Attorney</Button>
            <Button ml={10} onClick={() => { 
                if (!data) { return; } 
                setIsLoadingManual(true);
                App.Firebase.Write.updateUserData(userID + "", { }, data).then(() => {
                    setIsLoadingManual(false);
                });
            }}>Save Attorneys</Button>

                <Space h="md" />
                {data && data.attorneys && data?.attorneys
                .map((attorney, index) => {
                return (
                    <div key={`owner_${index.toString()}`}>
                        <AttorneyRow attorney={attorney} onAttorneyChange={(text: string) => { 
                            data.attorneys[index] = text; 
                            forceUpdate();
                        }} onDeleteClick={() => {
                            data.attorneys.splice(index, 1);
                            forceUpdate();
                        }} />
                    </div>
                );
            })}
        </Container>
    );
}

export default SettingsScreen;
